module.exports = __webpack_public_path__ + "img/sample07.e2e65e2b.gif";